export default __webpack_public_path__ + "static/media/drdong-sm-2x.36ec8166.jpg";